module.exports = __webpack_public_path__ + "media/images/city_img/q-e1cd4c96cdb4c79bb792e8b367803968.jpg";